import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { AuthProvider } from "./context/AuthContext";
import ProtectedRoute from "./components/ProtectedRoute";
import AppShell from "./components/AppShell";
import Login from "./pages/Login";
import Dashboard from "./pages/Dashboard";
import Recurring from "./pages/Recurring";
import Questions from "./pages/Questions";
import PaymentAdvices from "./pages/PaymentAdvices";
import Settings from "./pages/Settings";
import Activity from "./pages/Activity";
import History from "./pages/History";
import Close from "./pages/Close";
import Help from "./pages/Help";
import Welcome from "./pages/Welcome";
import Files from "./pages/Files";
import { Eula, Privacy, Disconnect } from "./pages/Legal";
import { Toaster } from "./components/ui/sonner";
import ErrorBoundary from "./components/ErrorBoundary";
import "./lib/toastConfig"; // silences non-error toasts globally
import "./App.css";

export default function App() {
  return (
    <ErrorBoundary>
      <AuthProvider>
        <BrowserRouter>
          <Routes>
            <Route path="/login" element={<Login />} />
            <Route path="/legal/eula" element={<Eula />} />
            <Route path="/legal/privacy" element={<Privacy />} />
            <Route path="/legal/disconnect" element={<Disconnect />} />
            <Route element={<ProtectedRoute />}>
              <Route element={<AppShell />}>
                <Route index element={<Navigate to="/recurring" replace />} />
                <Route path="/dashboard" element={<Dashboard />} />
                <Route path="/recurring" element={<Recurring />} />
                <Route path="/history" element={<History />} />
                <Route path="/questions" element={<Questions />} />
                <Route path="/payment-advices" element={<PaymentAdvices />} />
                {/* /expenses retired — redirect to Monthly Items so old bookmarks don't 404 */}
                <Route path="/expenses" element={<Navigate to="/recurring" replace />} />
                <Route path="/close" element={<Close />} />
                <Route path="/activity" element={<Activity />} />
                <Route path="/files" element={<Files />} />
                <Route path="/help" element={<Help />} />
                <Route path="/welcome" element={<Welcome />} />
                <Route path="/settings" element={<Settings />} />
              </Route>
            </Route>
          </Routes>
        </BrowserRouter>
        <Toaster position="top-right" />
      </AuthProvider>
    </ErrorBoundary>
  );
}
